import React, { ReactNode, useCallback, useEffect } from 'react';
import { Breadcrumb, Box, Typography, Button } from '@fpxfd/next';
import ActionArea from '@/components/ActionArea';
import styles from './index.module.scss';
import moment from 'moment';
import { useInterval } from '@/pages/Login/components/LoginBlock/utils';

export interface BtnProps {
  name: string | ReactNode;
  callback: (object) => void;
  loading?: boolean;
}

export interface PageHeaderProps {
  breadcrumbs?: Array<{ name: string; path?: string }>;
  title?: string | ReactNode;
  description?: string | ReactNode;
  descClassName?: string;
  slot?: string | ReactNode;
  btnList?: BtnProps[];
  rightSection?: string | ReactNode;
}

const PageHeader = ({
  breadcrumbs,
  title,
  description,
  descClassName,
  slot,
  btnList,
  rightSection,
  ...others
}: PageHeaderProps) => {
  useEffect(() => {
    document.title = document.getElementById('title')?.innerText || title || '';
  }, []);

  return (
    <Box spacing={8} className={styles.PageHeader} {...others}>
      {breadcrumbs && breadcrumbs.length > 0 ? (
        <Breadcrumb className={styles.Breadcrumbs} separator=" > ">
          {breadcrumbs.map((item) => (
            <Breadcrumb.Item link={item.path} key={item.path}>
              {item.name}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      ) : null}

      {title && (
        <Box direction="row" justify="space-between" align={'center'}>
          <Typography.Text className={styles.Title}>{title}</Typography.Text>
          {slot}
          {btnList && (
            <div className={styles.Btns}>
              {btnList?.map((e) => {
                return (
                  <Button type="primary" onClick={e.callback} loading={e?.loading}>
                    {e.name}
                  </Button>
                );
              })}
            </div>
          )}
          {rightSection}
        </Box>
      )}

      {description && (
        <Typography.Text className={`${styles.Description} ${descClassName}`}>{description}</Typography.Text>
      )}
    </Box>
  );
};

export default PageHeader;
